export enum UserBoosterType {
  None = 0,
  LevelExperience = 1,
  LeaguePoints = 2,
  Credits = 3,
}
